export const flagEmoji = (code) => {
  if (!code || code.length !== 2) return "";
  return code.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
};

export const COUNTRIES = [
  { code: "US", name: "United States" }, { code: "CA", name: "Canada" }, { code: "GB", name: "United Kingdom" },
  { code: "IE", name: "Ireland" }, { code: "AU", name: "Australia" }, { code: "NZ", name: "New Zealand" },
  { code: "FR", name: "France" }, { code: "DE", name: "Germany" }, { code: "ES", name: "Spain" },
  { code: "PT", name: "Portugal" }, { code: "IT", name: "Italy" }, { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" }, { code: "CH", name: "Switzerland" }, { code: "AT", name: "Austria" },
  { code: "SE", name: "Sweden" }, { code: "NO", name: "Norway" }, { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" }, { code: "PL", name: "Poland" }, { code: "CZ", name: "Czechia" },
  { code: "GR", name: "Greece" }, { code: "RO", name: "Romania" }, { code: "HU", name: "Hungary" },
  { code: "BR", name: "Brazil" }, { code: "MX", name: "Mexico" }, { code: "AR", name: "Argentina" },
  { code: "CL", name: "Chile" }, { code: "CO", name: "Colombia" }, { code: "PE", name: "Peru" },
  { code: "IN", name: "India" }, { code: "PK", name: "Pakistan" }, { code: "PH", name: "Philippines" },
  { code: "ID", name: "Indonesia" }, { code: "TH", name: "Thailand" }, { code: "VN", name: "Vietnam" },
  { code: "MY", name: "Malaysia" }, { code: "SG", name: "Singapore" }, { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" }, { code: "CN", name: "China" }, { code: "HK", name: "Hong Kong" },
  { code: "TW", name: "Taiwan" }, { code: "TR", name: "Turkey" }, { code: "RU", name: "Russia" },
  { code: "UA", name: "Ukraine" }, { code: "ZA", name: "South Africa" }, { code: "NG", name: "Nigeria" },
  { code: "EG", name: "Egypt" }, { code: "MA", name: "Morocco" }, { code: "SA", name: "Saudi Arabia" },
  { code: "AE", name: "United Arab Emirates" }, { code: "IL", name: "Israel" }, { code: "QA", name: "Qatar" },
];

export const countryName = (code) => (COUNTRIES.find((c) => c.code === code)?.name) || code || "";
